// models/metrics/metasearchMetrics/trivago-sl/trivagoSLMetrics.js

// conversion
import MetricBookingcountTrivagoSL from "models/metrics/metasearchMetrics/trivago-sl/conversion/MetricBookingcount";
import MetricConversionTrivagoSL from "models/metrics/metasearchMetrics/trivago-sl/conversion/MetricConversion";
import MetricRevenuePerclickTrivagoSL from "models/metrics/metasearchMetrics/trivago-sl/conversion/MetricRevenuePerclick";
import MetricRoiTrivagoSL from "models/metrics/metasearchMetrics/trivago-sl/performance/MetricRoi";

// performance
import MetricClicksTrivagoSL from "models/metrics/metasearchMetrics/trivago-sl/performance/MetricClicks";
import MetricCpcTrivagoSL from "models/metrics/metasearchMetrics/trivago-sl/performance/MetricCpc";
import MetricCsrTrivagoSL from "models/metrics/metasearchMetrics/trivago-sl/performance/MetricCsr";
import MetricCtrTrivagoSL from "models/metrics/metasearchMetrics/trivago-sl/performance/MetricCtr";
import MetricGeneratedTrivagoSL from "models/metrics/metasearchMetrics/trivago-sl/performance/MetricGenerated";
import MetricSpentTrivagoSL from "models/metrics/metasearchMetrics/trivago-sl/performance/MetricSpent";

// visibility
import MetricImprTrivagoSL from "models/metrics/metasearchMetrics/trivago-sl/performance/MetricImpr";

const trivagoSLMetrics = [
    // conversion
    new MetricBookingcountTrivagoSL(),
    new MetricConversionTrivagoSL(),
    new MetricRevenuePerclickTrivagoSL(),
    new MetricRoiTrivagoSL(),
    // performance
    new MetricClicksTrivagoSL(),
    new MetricCpcTrivagoSL(),
    new MetricCsrTrivagoSL(),
    new MetricCtrTrivagoSL(),
    new MetricGeneratedTrivagoSL(),
    new MetricSpentTrivagoSL(),
    // visibility
    new MetricImprTrivagoSL(),
];

export function findMetricById(metricId) {
    return trivagoSLMetrics.find((metricClass) => metricClass.field === metricId);
}

export default trivagoSLMetrics;
